import { IComboBoxOption } from '@fluentui/react';
import { ALL_FILES, DISTRIBUTION, FILENAME, POOL } from "./UUIFormFieldsView";
import { withAllFirst, serializePools, type SelectedKey } from "../../../helpers/PoolSelectionHelper";

export const getFileNameOptions = (usageFileNames: string[] = []) => {
    if (!usageFileNames?.length) {
        return [{ key: 'no-options', text: 'Files not available', disabled: true }];
    }
    const options = usageFileNames.map(file => ({ key: file, text: file }));
    const hasAll = usageFileNames.includes(ALL_FILES);
    return usageFileNames.length > 1
        ? (hasAll ? options : [{ key: ALL_FILES, text: 'All' }, ...options])
        : options;
}

export const formatParams = (jobControls, distributionValue: string, poolValue: SelectedKey[], poolOptions: IComboBoxOption[], filenameValue: string[]) => {
    return jobControls.map(control => {
        if (control.ControlID === DISTRIBUTION) {
            return { ControlID: control.ControlID, CurrentValue: distributionValue }
        }
        if (control.ControlID === POOL) {
            return {
                ControlID: control.ControlID,
                CurrentValue: serializePools(poolValue, withAllFirst(poolOptions))
            }
        }
        if (control.ControlID === FILENAME) {
            return { ControlID: control.ControlID, CurrentValue: filenameValue.join(", ") }
        }
    })
}